import React from 'react';
import LineChart from '../../assets/img/line-chart.svg';
import FunnelChart from '../../assets/img/graf-pill.svg';
import {
  LeadsComparisonGraph,
  ConversionGraph,
  ByTypeGraph,
  LineContent,
  LeadCard,
  TabsSection,
  GraphContainer,
  Circle,
  CircleRef,
  Refs
} from './styles';

const RendimientoSkeleton = ({ isDesktop }) => {
  return (
    <>
      <LeadsComparisonGraph isDesktop={isDesktop}>
        <section>
          <LeadCard>
            <LineContent width='48px' height='48px' isCircular />
            <section>
              {isDesktop && <LineContent width='100px' marginBottom='16px' />}
              <LineContent width='100px' marginBottom='16px' />
              <LineContent width='180px' />
            </section>
          </LeadCard>
          <LeadCard>
            <LineContent width='48px' height='48px' isCircular />
            <section>
              {isDesktop && <LineContent width='100px' marginBottom='16px' />}
              <LineContent width='100px' marginBottom='16px' />
              <LineContent width='180px' />
            </section>
          </LeadCard>
          <LeadCard>
            <LineContent width='48px' height='48px' isCircular />
            <section>
              {isDesktop && <LineContent width='100px' marginBottom='16px' />}
              <LineContent width='100px' marginBottom='16px' />
              <LineContent width='180px' marginBottom='16px' />
              <LineContent width='140px' />
            </section>
          </LeadCard>
        </section>
        {isDesktop && (
          <>
            <TabsSection>
              <LineContent width='120px' />
              <LineContent width='120px' />
              <LineContent width='120px' />
            </TabsSection>
            <GraphContainer>
              <img src={LineChart} alt='Line Chart' width='100%' />
              <LineContent width='100px' />
            </GraphContainer>
          </>
        )}
      </LeadsComparisonGraph>
      <section className='multiGraph'>
        <ConversionGraph isDesktop={isDesktop}>
          <section>
            <LineContent width='48px' height='48px' isCircular />
            <LineContent width='100px' />
          </section>
          <div className='imgContainer'>
            <img src={FunnelChart} alt='Funnel Chart' />
          </div>
        </ConversionGraph>
        <ByTypeGraph>
          <section>
            <LineContent width='48px' height='48px' isCircular />
            <LineContent width='100px' />
          </section>
          <Circle />
          <Refs>
            <CircleRef>
              <div className='ref-point' />
              <LineContent width='100px' />
            </CircleRef>
            <CircleRef>
              <div className='ref-point' />
              <LineContent width='160px' />
            </CircleRef>
            <CircleRef>
              <div className='ref-point' />
              <LineContent width='130px' />
            </CircleRef>
          </Refs>
        </ByTypeGraph>
      </section>
    </>
  );
};

export default RendimientoSkeleton;
